/* eslint-disable standard/no-callback-literal */
import axios from "axios";

// eslint-disable-next-line no-unused-vars
var callback;

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function createPopUpAds(data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        description: data.deskripsi,
        external_url: data.url,
        deeplink: data.deeplink,
        page_direction: data.page_direction,
        image: data.image,
        start_date: data.start_at,
        end_date: data.end_at,
        start_time: data.start_time,
        end_time: data.end_time,
        user_group: data.user_group,
        is_ios: data.is_ios,
        is_active: data.is_active,
        is_android: data.is_android,
        is_webapp: data.is_webapp,
        is_webpurchase: data.is_webpurchase,
    };

    http.post("general-service/pop-ads/create", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updatePopUpAds(id, data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        description: data.deskripsi,
        external_url: data.url,
        deeplink: data.deeplink,
        page_direction: data.page_direction,
        image: data.image,
        start_date: data.start_at,
        end_date: data.end_at,
        start_time: data.start_time,
        end_time: data.end_time,
        user_group: data.user_group,
        is_ios: data.is_ios,
        is_active: data.is_active,
        is_android: data.is_android,
        is_webapp: data.is_webapp,
        is_webpurchase: data.is_webpurchase,
    };

    http.put(
        "/general-service/pop-ads/update?pop_ads_id=" + id,
        postData,
        config,
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListPopUpAds(callback) {
    var config = getConfig();

    http.get("general-service/pop-ads/get-list", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailPopUpAds(id, callback) {
    var config = getConfig();

    http.get("general-service/pop-ads/detail?pop_ads_id=" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function changeSequence(dataBody, callback) {
    var config = getConfig();
    http.put("/general-service/pop-ads/nourut", dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}
export default {
    createPopUpAds,
    updatePopUpAds,
    getListPopUpAds,
    getDetailPopUpAds,
    changeSequence,
};



// WEBPACK FOOTER //
// ./src/modules/pop_up_ads/services/pop_up_ads.js